const lang={
    en:{
        Header: "is an online community of travelers where people share their experiences and info about trips.",
        btnText: "Join the Community Now!!",
        feedHeading:"Catch up with Others",
        groupHeading:"Join like Minded Groups",
        groupP1:"Unity in Diversity",
        groupP2:"Meet new people in community, know them and join them if you want to travel along with them.",
        placesHeading:"Explore places in the City",
        messageHeading:"Interact with community members",
        messageP1:"Chat with group leaders to join, comment, like and follow other members in the community, get engaged and get going."
},
    hindi:{
        Header: "यात्रियों का एक ऑनलाइन समुदाय है जहां लोग यात्राओं के बारे में अपने अनुभव और जानकारी साझा करते हैं।",
        btnText: "अभी समुदाय में शामिल हों!!",
        feedHeading:"अन्य लोगों से मिलें",
        groupHeading:"समान विचारधारा वाले समूहों से जुड़ें",
        groupP1:"अनेकता में एकता",
        groupP2:"समुदाय में नए लोगों से मिलें, उन्हें जानें और यदि आप उनके साथ यात्रा करना चाहते हैं तो उनके साथ जुड़ें।",
        placesHeading:"शहर की जगहों के बारे में जानें",
        messageHeading:"समुदाय के सदस्यों के साथ बातचीत करें",
        messageP1:"समूहों में शामिल होने के लिए समूह प्रमुख से चैट करें। टिप्पणी करें, पसंद करें और समुदाय के अन्य सदस्यों को फ़ॉलो करें और समूह के साथ आनंद लें"
    },
    spanish:{
        Header: "es una comunidad en línea de viajeros donde las personas comparten sus experiencias e información sobre viajes.",
        btnText: "¡Únete a la comunidad ahora!",
        feedHeading:"Reunirse con otras",
        groupHeading:"Únase a grupos con ideas afines",
        groupP1:"Unidad en la diversidad",
        groupP2:"Conoce gente nueva en la comunidad, conócelos y únete a ellos si quieres viajar con ellos.",
        placesHeading:"Explora lugares de la ciudad",
        messageHeading:"Interactuar con miembros de la comunidad",
        messageP1:"Charle con los líderes del grupo para unirse, comentar, dar me gusta y seguir a otros miembros de la comunidad, participar y ponerse en marcha."
    }
}

export default lang